import * as React from "react";
import { forwardRef } from "react";

import DynamicData from "@svg/dynamic-data";

import IconButton from "@replo/design-system/components/button/IconButton";

type DynamicDataButtonProps = {
  tooltipText?: string;
} & React.ComponentPropsWithoutRef<"button">;

const DynamicDataButton = forwardRef<HTMLButtonElement, DynamicDataButtonProps>(
  ({ onClick, tooltipText = "Add Dynamic Data" }, ref) => {
    return (
      <IconButton
        ref={ref}
        type="button"
        size="sm"
        variant="secondary"
        onClick={onClick ?? undefined}
        icon={<DynamicData />}
        tooltipText={tooltipText}
      />
    );
  },
);

DynamicDataButton.displayName = "DynamicDataButton";

export default DynamicDataButton;
